import { firebaseDb as db } from '../firebase'
import { asyncRequest, asyncSuccess, asyncFail, cleanMessages } from '../actions'

// action types

// action creators
export const fetchAppointments = (projectId, userId = null) => {
  return dispatch => {
    dispatch(asyncRequest('fetchAppointments'))

    let logsRef = null
    if (userId) {
      // get current user's appointments (for assignee)
      logsRef = db
        .collection('projects')
        .doc(projectId)
        .collection('logs')
        .where('data.reachedType', '==', 'appointment')
        .where('data.assignee', '==', userId)
    } else {
      // get all appointments (for admins/agent)
      logsRef = db
        .collection('projects')
        .doc(projectId)
        .collection('logs')
        .where('data.reachedType', '==', 'appointment')
    }

    logsRef
      .get()
      .then(logsSnap => {
        const appointments = []

        logsSnap.forEach(doc => {
          appointments.push(doc.data())
        })

        dispatch(asyncSuccess('fetchAppointments', { appointments }, null))
      })
      .catch(error => {
        console.log(error)
        dispatch(asyncFail('fetchAppointments', error.code))
        dispatch(cleanMessages())
      })
  }
}



// WEBPACK FOOTER //
// ./src/actions/appointments.js